"use strict";

require("core-js/modules/web.dom-collections.iterator");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.MiniCart = void 0;

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _reactFontawesome = require("@fortawesome/react-fontawesome");

var _proRegularSvgIcons = require("@fortawesome/pro-regular-svg-icons");

var _proLightSvgIcons = require("@fortawesome/pro-light-svg-icons");

var _ItemsContainer = _interopRequireDefault(require("./ItemsContainer"));

var _styles = _interopRequireDefault(require("./styles"));

var _apis = require("./apis");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

var EmptyCartSVG = function EmptyCartSVG(props) {
  return /*#__PURE__*/_react.default.createElement("svg", props, /*#__PURE__*/_react.default.createElement("defs", null, /*#__PURE__*/_react.default.createElement("filter", {
    id: "a",
    filterUnits: "userSpaceOnUse",
    x: "1.6",
    y: "1.9",
    width: "68.7",
    height: "54.1"
  }, /*#__PURE__*/_react.default.createElement("feColorMatrix", {
    values: "1 0 0 0 0 0 1 0 0 0 0 0 1 0 0 0 0 0 1 0"
  }))), /*#__PURE__*/_react.default.createElement("mask", {
    maskUnits: "userSpaceOnUse",
    x: "1.6",
    y: "1.9",
    width: "68.7",
    height: "54.1",
    id: "b"
  }, /*#__PURE__*/_react.default.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    fill: "#fff",
    d: "M.6 1.3h73.5v60H.6z",
    filter: "url(#a)"
  })), /*#__PURE__*/_react.default.createElement("g", {
    mask: "url(#b)"
  }, /*#__PURE__*/_react.default.createElement("g", {
    transform: "rotate(132 30.208 28.768)"
  }, /*#__PURE__*/_react.default.createElement("g", {
    transform: "translate(0 .105)"
  }, /*#__PURE__*/_react.default.createElement("linearGradient", {
    id: "c",
    gradientUnits: "userSpaceOnUse",
    x1: "787.992",
    y1: "21.609",
    x2: "788.646",
    y2: "21.007",
    gradientTransform: "matrix(-8.4257 -9.2299 -9.3577 8.3106 6853.362 7140.472)"
  }, /*#__PURE__*/_react.default.createElement("stop", {
    offset: "0",
    stopColor: "#3862c5"
  }), /*#__PURE__*/_react.default.createElement("stop", {
    offset: "1",
    stopColor: "#2b4dac"
  })), /*#__PURE__*/_react.default.createElement("path", {
    d: "M15.8 37.2c3.5 0 6.3 2.8 6.3 6.2 0 3.4-2.8 6.2-6.3 6.2s-6.3-2.8-6.3-6.2c0-3.5 2.8-6.2 6.3-6.2z",
    fill: "url(#c)"
  }), /*#__PURE__*/_react.default.createElement("linearGradient", {
    id: "d",
    gradientUnits: "userSpaceOnUse",
    x1: "787.992",
    y1: "21.609",
    x2: "788.646",
    y2: "21.007",
    gradientTransform: "matrix(-8.4257 -9.2299 -9.3577 8.3106 6884.843 7140.472)"
  }, /*#__PURE__*/_react.default.createElement("stop", {
    offset: "0",
    stopColor: "#3862c5"
  }), /*#__PURE__*/_react.default.createElement("stop", {
    offset: "1",
    stopColor: "#2b4dac"
  })), /*#__PURE__*/_react.default.createElement("path", {
    d: "M47.2 37.2c3.5 0 6.3 2.8 6.3 6.2 0 3.4-2.8 6.2-6.3 6.2s-6.3-2.8-6.3-6.2 2.9-6.2 6.3-6.2z",
    fill: "url(#d)"
  }), /*#__PURE__*/_react.default.createElement("linearGradient", {
    id: "e",
    gradientUnits: "userSpaceOnUse",
    x1: "826.287",
    y1: "-17.125",
    x2: "827",
    y2: "-17.78",
    gradientTransform: "matrix(-4.2128 -4.6149 -4.6788 4.1553 3414.35 3929.894)"
  }, /*#__PURE__*/_react.default.createElement("stop", {
    offset: "0",
    stopColor: "#f4f5f6"
  }), /*#__PURE__*/_react.default.createElement("stop", {
    offset: "1",
    stopColor: "#dedfe2"
  })), /*#__PURE__*/_react.default.createElement("path", {
    d: "M15.8 40.3c1.7 0 3.1 1.4 3.1 3.1s-1.4 3.1-3.1 3.1c-1.7 0-3.1-1.4-3.1-3.1-.1-1.7 1.3-3.1 3.1-3.1z",
    fill: "url(#e)"
  }), /*#__PURE__*/_react.default.createElement("linearGradient", {
    id: "f",
    gradientUnits: "userSpaceOnUse",
    x1: "826.664",
    y1: "-17.959",
    x2: "826.664",
    y2: "-16.986",
    gradientTransform: "matrix(-4.2128 -4.6149 -4.6788 4.1553 3445.831 3929.894)"
  }, /*#__PURE__*/_react.default.createElement("stop", {
    offset: "0",
    stopColor: "#f4f5f6"
  }), /*#__PURE__*/_react.default.createElement("stop", {
    offset: "1",
    stopColor: "#dedfe2"
  })), /*#__PURE__*/_react.default.createElement("path", {
    d: "M47.2 40.3c1.7 0 3.1 1.4 3.1 3.1 0 1.7-1.4 3.1-3.1 3.1-1.7 0-3.1-1.4-3.1-3.1s1.4-3.1 3.1-3.1z",
    fill: "url(#f)"
  }), /*#__PURE__*/_react.default.createElement("linearGradient", {
    id: "g",
    gradientUnits: "userSpaceOnUse",
    x1: "762.259",
    y1: "48.009",
    x2: "762.854",
    y2: "47.625",
    gradientTransform: "matrix(-35.0209 -28.8456 -38.8947 25.9727 28575.078 20762.955)"
  }, /*#__PURE__*/_react.default.createElement("stop", {
    offset: "0",
    stopColor: "#b9bbc1"
  }), /*#__PURE__*/_react.default.createElement("stop", {
    offset: "1",
    stopColor: "#6e727c"
  })), /*#__PURE__*/_react.default.createElement("path", {
    d: "M3.2-.1c5.6 0 10.1 4.4 10.2 9.8v.3h33.8c3.4 0 6.2 2.7 6.3 6v4.9c0 4.3-2.3 8.3-6 10.6l-.3.2-9.4 5.4c-3.8 2.2-8.4 2.2-12.3.2l-.3-.2-9.4-5.4c-3.8-2.2-6.2-6.1-6.3-10.4V10.1c0-3.4-2.8-6.2-6.3-6.2-1.1 0-2-.9-2-1.9 0-1.2.9-2.1 2-2.1zM26 24h-4.7v7H26v-7zm7.9 0h-4.7v7h4.7v-7zm7.8 0H37v7h4.7v-7zm8.3 0h-5.1v5.8l.1-.1c2.5-1.3 4.2-3.3 5-5.7zm-32 5.7l.1.1V24H13c.8 2.4 2.6 4.4 5 5.7zm29.3-16.6h-2.4v7h5.5v-3.9c0-1.8-1.3-3.1-3.1-3.1zm-29.2 0h-5.5v7h5.5v-7zm7.9 0h-4.7v7H26v-7zm7.9 0h-4.7v7h4.7v-7zm7.8 0H37v7h4.7v-7z",
    fillRule: "evenodd",
    clipRule: "evenodd",
    fill: "url(#g)"
  })), /*#__PURE__*/_react.default.createElement("linearGradient", {
    id: "h",
    gradientUnits: "userSpaceOnUse",
    x1: "851.815",
    y1: "-42.911",
    x2: "852.503",
    y2: "-43.523",
    gradientTransform: "matrix(-3.1596 -3.4616 -3.5091 3.1168 2542.373 3086.144)"
  }, /*#__PURE__*/_react.default.createElement("stop", {
    offset: "0",
    stopColor: "#3862c5"
  }), /*#__PURE__*/_react.default.createElement("stop", {
    offset: "1",
    stopColor: "#2b4dac"
  })), /*#__PURE__*/_react.default.createElement("path", {
    d: "M3.2 0c1.3 0 2.4 1 2.4 2.3 0 1.3-1.1 2.3-2.4 2.3-1.3 0-2.4-1-2.4-2.3C.8 1.1 1.9 0 3.2 0z",
    fillRule: "evenodd",
    clipRule: "evenodd",
    fill: "url(#h)"
  }))), /*#__PURE__*/_react.default.createElement("defs", null, /*#__PURE__*/_react.default.createElement("filter", {
    id: "i",
    filterUnits: "userSpaceOnUse",
    x: "41.3",
    y: "50",
    width: "7",
    height: "8.5"
  }, /*#__PURE__*/_react.default.createElement("feColorMatrix", {
    values: "1 0 0 0 0 0 1 0 0 0 0 0 1 0 0 0 0 0 1 0"
  }))), /*#__PURE__*/_react.default.createElement("mask", {
    maskUnits: "userSpaceOnUse",
    x: "41.3",
    y: "50",
    width: "7",
    height: "8.5",
    id: "j"
  }, /*#__PURE__*/_react.default.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    fill: "#fff",
    d: "M.6 1.3h73.5v60H.6z",
    filter: "url(#i)"
  })), /*#__PURE__*/_react.default.createElement("linearGradient", {
    id: "k",
    gradientUnits: "userSpaceOnUse",
    x1: "-420.449",
    y1: "609.83",
    x2: "-419.47",
    y2: "610.559",
    gradientTransform: "matrix(-.5731 8.1952 7.4744 .5227 -4757.253 3177.084)"
  }, /*#__PURE__*/_react.default.createElement("stop", {
    offset: "0",
    stopColor: "#8bc34a"
  }), /*#__PURE__*/_react.default.createElement("stop", {
    offset: ".279",
    stopColor: "#ffca28"
  }), /*#__PURE__*/_react.default.createElement("stop", {
    offset: "1",
    stopColor: "#ffa000"
  })), /*#__PURE__*/_react.default.createElement("path", {
    d: "M48.1 58.3c-.6.2-1.4.3-2.1.3-2.5-.2-4.5-1.9-4.5-4.1 0-1.2.6-2 1.3-2.4-.6-.8-1.2-1.1-1.3-1.1-.2-.1-.3-.4-.2-.6.1-.2.4-.3.6-.2.8.4 3 2.1 2.7 5.6 0 .1.1.2.2.2s.2-.1.2-.2c.1-1.9-.3-3.2-.9-4.2h.3c1.5.1 2.7 1.4 2.6 2.9v1.2c-.1.9.4 1.7 1.1 2.2.2.1.2.3 0 .4z",
    mask: "url(#j)",
    fill: "url(#k)"
  }), /*#__PURE__*/_react.default.createElement("defs", null, /*#__PURE__*/_react.default.createElement("filter", {
    id: "l",
    filterUnits: "userSpaceOnUse",
    x: "52.3",
    y: "45.9",
    width: "13",
    height: "7.4"
  }, /*#__PURE__*/_react.default.createElement("feColorMatrix", {
    values: "1 0 0 0 0 0 1 0 0 0 0 0 1 0 0 0 0 0 1 0"
  }))), /*#__PURE__*/_react.default.createElement("mask", {
    maskUnits: "userSpaceOnUse",
    x: "52.3",
    y: "45.9",
    width: "13",
    height: "7.4",
    id: "m"
  }, /*#__PURE__*/_react.default.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    fill: "#fff",
    d: "M.6 1.3h73.5v60H.6z",
    filter: "url(#l)"
  })), /*#__PURE__*/_react.default.createElement("linearGradient", {
    id: "n",
    gradientUnits: "userSpaceOnUse",
    x1: "-409.038",
    y1: "526.191",
    x2: "-408.116",
    y2: "527.182",
    gradientTransform: "matrix(8.4812 5.2996 5.2753 -8.4422 746.145 6661.242)"
  }, /*#__PURE__*/_react.default.createElement("stop", {
    offset: "0",
    stopColor: "#8bc34a"
  }), /*#__PURE__*/_react.default.createElement("stop", {
    offset: ".256",
    stopColor: "#ffc107"
  }), /*#__PURE__*/_react.default.createElement("stop", {
    offset: "1",
    stopColor: "#ff8a65"
  })), /*#__PURE__*/_react.default.createElement("path", {
    d: "M65.3 47.3c-.2.9-.5 1.8-1.1 2.6-1.8 2.8-4.9 4.1-7.3 2.9-1.3-.6-1.8-1.8-1.8-2.8-1.2.2-1.9.8-2 .8-.3.2-.6.2-.8-.1-.2-.3-.1-.6.2-.8.9-.7 4.1-2.3 7.8 0 .1.1.3 0 .4-.1.1-.1.1-.3-.1-.4-1.9-1.2-3.7-1.4-5.1-1.2.1-.1.1-.2.2-.3 1.1-1.7 3.3-2.4 4.8-1.4l1.2.7c.9.6 2.1.5 3.1-.1.3-.2.5-.1.5.2z",
    mask: "url(#m)",
    fill: "url(#n)"
  }));
};

EmptyCartSVG.defaultProps = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 72 60",
  enableBackground: "new 0 0 72 60"
};
const {
  MiniCartContainer,
  Header,
  Body,
  Loader,
  EmptyCart,
  Footer
} = _styles.default;

const MiniCart = props => {
  const {
    className,
    popup,
    toggle,
    setToggle,
    cart,
    onCartUpdate,
    env,
    accountHasContractCodes,
    isLoadingCart,
    testMode,
    isPunchout,
    newPageOnClick,
    checkoutClick
  } = props;
  const [animate, setAnimate] = (0, _react.useState)(false);
  const [rendered, setRendered] = (0, _react.useState)(false);
  const [numOfItems, setNumOfItems] = (0, _react.useState)(cart.CartItemTotal);
  (0, _react.useEffect)(() => {
    setRendered(true);
  }, []);
  (0, _react.useEffect)(() => {
    if (rendered && popup) setAnimate(true);
  }, [toggle]);
  (0, _react.useEffect)(() => {
    setNumOfItems(cart.CartItemTotal);
  }, [props.cart]);

  const blurFunc = () => {
    if (_.has(props, 'onBlur')) {
      props.onBlur();
    }
  };

  const focusFunc = () => {
    if (_.has(props, 'onFocus')) {
      props.onFocus(true);
    }
  };

  return /*#__PURE__*/_react.default.createElement(MiniCartContainer, {
    className: 'mini-cart-component' + (className && ' ' + className) + (animate && ' animate'),
    toggle: toggle,
    popup: popup,
    tabIndex: props.tabIndex || '1',
    onMouseEnter: event => focusFunc(event),
    onMouseLeave: event => blurFunc(event)
  }, popup && /*#__PURE__*/_react.default.createElement(Header, {
    className: "mini-cart-header"
  }, /*#__PURE__*/_react.default.createElement("p", {
    className: "mini-cart-title micro"
  }, "Your Cart", ' ', !isLoadingCart && numOfItems !== 0 && /*#__PURE__*/_react.default.createElement("span", {
    className: "fade-in"
  }, "(", numOfItems, " item", numOfItems > 1 && 's', ")"), ' '), /*#__PURE__*/_react.default.createElement(_reactFontawesome.FontAwesomeIcon, {
    icon: _proLightSvgIcons.faTimes,
    onClick: () => setToggle(!toggle)
  })), /*#__PURE__*/_react.default.createElement(Body, {
    className: "mini-cart-body"
  }, isLoadingCart ? /*#__PURE__*/_react.default.createElement(Loader, {
    className: "mini-cart-loader fade-in"
  }, /*#__PURE__*/_react.default.createElement(_reactFontawesome.FontAwesomeIcon, {
    className: "loader-icon",
    icon: _proRegularSvgIcons.faSpinnerThird
  }), /*#__PURE__*/_react.default.createElement("h5", null, "Loading your cart\u2026")) : /*#__PURE__*/_react.default.createElement(_react.Fragment, null, isPunchout && /*#__PURE__*/_react.default.createElement("p", {
    className: "punchout-message"
  }, /*#__PURE__*/_react.default.createElement("i", {
    className: "far fa-info-circle"
  }), "Not seeing what you added? To get your punch-out items into this universal cart, you need to first completely check out on the supplier's site. Once you've submitted that cart, your items will show up here and can be ordered."), numOfItems > 0 ? /*#__PURE__*/_react.default.createElement(_ItemsContainer.default, {
    cart: cart,
    onCartUpdate: onCartUpdate,
    setNumOfItems: setNumOfItems,
    testMode: testMode,
    env: env
  }) : /*#__PURE__*/_react.default.createElement(EmptyCart, {
    className: "mini-cart-empty fade-in"
  }, props.emptyCartIcon && /*#__PURE__*/_react.default.createElement("img", {
    alt: "emptycart",
    className: "emptyCartImg",
    src: props.emptyCartIcon
  }), !props.emptyCartIcon && /*#__PURE__*/_react.default.createElement(EmptyCartSVG, null), /*#__PURE__*/_react.default.createElement("p", null, "Your cart is empty"), props.emptyCartExtraText && /*#__PURE__*/_react.default.createElement(_react.Fragment, null, props.emptyCartExtraText)))), cart && numOfItems > 0 && /*#__PURE__*/_react.default.createElement(Footer, {
    className: "mini-cart-footer"
  },
  /*#__PURE__*/_react.default.createElement("a", {
    className: "footer-btn view-cart-btn",
    style: {
      background: accountHasContractCodes ? 'rgba(34, 68, 253, 1)' : 'linear-gradient(-180deg,rgb(255,255,255) 0%,rgb(250,250,250) 100%)',
      borderRadius: 4,
      color: accountHasContractCodes ? '#FFFFFF' : '#3963fe',
      fontSize: accountHasContractCodes ? 14 : '0.75rem',
      fontWeight: 500,
      fontFamily: 'Rubik',
      border: accountHasContractCodes ? 'none' : '1px solid rgb(244,245,246)',
      borderRadius: accountHasContractCodes ? 4  : '0.5rem'
    },
    href: env.marketplaceRoot + '/cart',
    target: newPageOnClick ? '_blank' : ''
  }, "View cart"),
  
  checkoutClick && !accountHasContractCodes &&
  /*#__PURE__*/_react.default.createElement("button", {
    className: "footer-btn checkout-btn",
    onClick: () => {
      if (!testMode) (0, _apis.postAnalytics)('mini-cart-checkout', {
        cart
      }, env);
      checkoutClick();
    }
  }, "Checkout"),
  
  !checkoutClick && !accountHasContractCodes &&
  /*#__PURE__*/_react.default.createElement("a", {
    className: "footer-btn checkout-btn",
    href: env.marketplaceRoot + '/checkout',
    target: newPageOnClick ? '_blank' : '',
    onClick: () => {
      if (!testMode) (0, _apis.postAnalytics)('mini-cart-checkout', {
        cart
      }, env);
    }
  }, "Checkout")));
};

exports.MiniCart = MiniCart;
MiniCart.propTypes = {
  className: _propTypes.default.string,
  cart: _propTypes.default.object.isRequired,
  isLoadingCart: _propTypes.default.bool.isRequired,
  popup: _propTypes.default.bool.isRequired,
  toggle: _propTypes.default.bool,
  setToggle: _propTypes.default.func,
  onCartUpdate: _propTypes.default.func.isRequired,
  newPageOnClick: _propTypes.default.bool,
  checkoutClick: _propTypes.default.func,
  env: _propTypes.default.shape({
    apiRoot: _propTypes.default.string.isRequired,
    apiKey: _propTypes.default.string.isRequired,
    bearerToken: _propTypes.default.string.isRequired,
    userToken: _propTypes.default.string.isRequired,
    marketplaceRoot: _propTypes.default.string.isRequired,
    userData: _propTypes.default.object.isRequired
  }),
  testMode: _propTypes.default.bool
};
var _default = MiniCart;
exports.default = _default;